import Vue from 'vue'
import './optimized-resize'

import debug from './debug'
Vue.use(debug)

import handler from './handler'
Vue.use(handler)

import crontab from './crontab'
Vue.use(crontab)

import routeHook from './route-hook'
Vue.use(routeHook)

import i18n from './i18n'
Vue.use(i18n)

import mqtt from './mqtt'
Vue.use(mqtt)

import storage from './storage'
Vue.use(storage)

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

import firebase from './firebase'
Vue.use(firebase)

export default Vue
